/****************************************************************************************************/
/* Module Imports */
/****************************************************************************************************/

require("./mobile-menu.js");
require('jquery-lazy');
//require('jquery-backstretch');
//require('jquery-hoverintent');
require("waypoints/lib/jquery.waypoints.js");
require("waypoints/lib/shortcuts/sticky.js");
require("jquery-ui/ui/unique-id.js");
require("jquery-ui/ui/focusable.js");
require("jquery-ui/ui/tabbable");
require("jquery-ui/ui/scroll-parent.js");
//require("page-scroll-to-id/jquery.malihu.PageScroll2id.js");

var popup = require("jquery-popup-overlay");
import { Splide } from '@splidejs/splide';
//import { Grid } from '@splidejs/splide-extension-grid';

require('@splidejs/splide/dist/css/splide.min.css');
require('@splidejs/splide/dist/css/themes/splide-default.min.css');
window.Splide = Splide; // make splide available to widget scripts

require("@iconfu/svg-inject/dist/svg-inject.min.js");

/****************************************************************************************************/
/* Global Vars */
/****************************************************************************************************/

window.ww; // window width
window.wh; // window width
window.hh;
window.selectedClassName = 'selected'; // the selected class name for menu items
window.menuOpenClassName = 'open'; // the class that defines the open state of the menu
window.fadeInSpeed = 50; // the fade in transition speed
window.fadeOutSpeed = 75; // the fade out transition speed
window.navMouseOutDelay = 600; // the delay before the nav disappears on mouseout
window.mouseOutTimer; // the MouseOut timeout timer 
window.is_responsive = false;
window.lastScrollTop = 0; // used for tracking scroll position and direction
window.scrollDirection = "down"; // default
window.st = window.pageYOffset || document.documentElement.scrollTop;
var $header = $("#header");
function refreshScrollData() {
  // Gets the scrollTop and direction and updates the global variables accordingly
  window.st = window.pageYOffset || document.documentElement.scrollTop;
  if (window.st > lastScrollTop) {
    window.scrollDirection = "down";
  } else {
    window.scrollDirection = "up";
  }
  if (window.st <= window.hh) {
    $header.addClass("near-top");
  } else {
    $header.removeClass("near-top");
  }
  lastScrollTop = window.st <= 0 ? 0 : window.st; // For Mobile or negative scrolling
}

function refreshDimensions() {
  // update calculated dimensions (to be used on resize events, or anytime a manual refresh is required)
  window.ww = document.documentElement.clientWidth; //$(window).width(); - CHANGED to avoid reflows.
  window.wh = document.documentElement.clientHeight; //$(window).height(); - CHANGED to avoid reflows.
  window.hh = $(".header").outerHeight() + $(".topHeader").outerHeight(); // $("header").outerHeight();

  // Check if we are in Mobile (ie Responsive mode)
  if ($('.hamburger').is(":visible")) {
    is_responsive = true;
  } else {
    is_responsive = false;
  }

  // padding to match fixed header height
  //if ($header && $header.length) { //  && is_responsive
  //    $("#wrapper").css({ paddingTop: hh + "px" });
  //    $("header").css({ height: hh + "px" });
  //} else {
  //    $("#wrapper").css({ paddingTop: 0 });
  //}

  if (!isSitefinityEditor()) {
    refreshScrollData(); // refresh scroll data just in case...
    refreshForcedWidthContainers();
  }
}

/****************************************************************************************************/
/* Containers */
/****************************************************************************************************/

function refreshScrollbarWidthValue() {
  var scrollbarWidth = 16; // px (standard measured manually on Chrome)
  try {
    scrollbarWidth = getScrollbarWidth();
  } catch {
    console.log("unable to calculate scrollbar width automatically.");
  }
}
function getTopLevelScrollBarWidth() {
  var scrollbarWidth = 0;
  if (document.body.scrollHeight > document.body.clientHeight || document.documentElement.scrollHeight > document.documentElement.clientHeight) {
    scrollbarWidth = getScrollbarWidth();
  }
  return scrollbarWidth;
}

/* Updates the max-width of edge-to-edge containers to account for scrollbars */
function refreshForcedWidthContainers() {
  //var scrollbarWidth = 16; // px (standard measured manually on Chrome)
  //try {
  //    scrollbarWidth = getScrollbarWidth();
  //    console.log({ scrollbarWidth });
  //}
  //catch {
  //    console.log("unable to calculate scrollbar width automatically.");
  //}
  var scrollbarWidth = getTopLevelScrollBarWidth();
  //var width = "calc(100vw - " + scrollbarWidth + "px)";
  //var $forcedWidthContainers = $(".container.edge, .container.force");
  //$forcedWidthContainers.each(function () {
  //    $(this).css({
  //        //width: width,
  //        maxWidth: "100vw"
  //    });
  //});
  //$edgeWidthContainers.each(function () {
  //    $(this).css({
  //        //width: width,
  //        maxWidth: "100vw"
  //    });
  //});
  // ToDo: try doing this with a custom property instead:
  let root = document.documentElement;
  root.style.setProperty('--scrollbar-width', scrollbarWidth + "px");
}
function getScrollbarWidth() {
  //debugger;

  // Creating invisible container
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);
  return scrollbarWidth;
}
/****************************************************************************************************/
/* Document Ready */
/****************************************************************************************************/

window.addEventListener('DOMContentLoaded', function () {
  $header = $("#header");
  refreshDimensions();
  $(window).trigger('resize');
  setTimeout(refreshDimensions, 2000); // re-run after a few seconds to capture any late layout shifts (from fonts loading or other)
});

/****************************************************************************************************/
/* Scroll Events */
/****************************************************************************************************/

var mainScrollEvent = function () {
  $header = $("#header");
  refreshScrollData();

  // Scroll-to-top link
  if (lastScrollTop > 450) {
    $('.scrollToTop').fadeIn();
  } else {
    $('.scrollToTop').fadeOut();
  }
  $header.removeClass("down up").addClass(window.scrollDirection);
  if (lastScrollTop === 0) {
    $header.addClass("top");
  } else {
    $header.removeClass("top");
  }
};

// optimized event handler: https://web.dev/uses-passive-event-listeners/
document.addEventListener('scroll', mainScrollEvent, {
  passive: true
});

/****************************************************************************************************/
/* Window Resizing */
/****************************************************************************************************/

$(window).on('resize', function () {
  refreshDimensions();
});

/****************************************************************************************************/
/* Sliders / Carousels */
/****************************************************************************************************/

/* multi-item slider: on mounted (prevent issues with looping, perPage, arrows, etc ) */
function onMountedMultiItemSlider(splide) {
  console.log("multi-item slider mounted!", splide);
  if (!splide.options.fixedWidth && !splide.options.autoWidth) {
    if (splide.options.perPage && splide.Components.Slides.getLength(true) <= splide.options.perPage) {
      //debugger;
      $(splide.root).addClass("noSliderNeeded"); // add a class so we can adjust styling if needed
      splide.options.drag = false;
      splide.options.noDrag = "*"; // I don't think we should need this, however for now it prevents unwanted dragging even when drag is disabled.
      splide.options.arrows = false;
      splide.options.pagination = false;
      splide.options.type = 'slide';
      splide.options.classes.arrows += " hiddenArrows";
      $(splide.Components.Elements.arrows).attr("class", splide.options.classes.arrows); // force our custom HTML arrows to use the reactive Splide classes
      //splide.Components.Arrows.destroy(); // doesn't work ...
      splide.refresh();
    }
  }
}

/* auto-height slider: shared event callbacks */
var autoHeightEvents = {
  mounted: onMountedAutoHeightSlider,
  refresh: onMountedAutoHeightSlider,
  move: onMoveAutoHeightSlider
};

/* updates the slider height during the slider move event */
function onMoveAutoHeightSlider(newIndex, prevIndex, destIndex, splide) {
  var height = $(splide.Components.Elements.slides[newIndex]).outerHeight();
  updateSliderHeight(splide, height);
}
function onMountedAutoHeightSlider(splide) {
  //if (splide.Components.Elements.slides.length <= 1) {
  //    splide.destroy();
  //    $(splide.root).find(".splide__arrows").hide();
  //}
  $(splide.root).find(".splide__list").css({
    alignItems: "flex-start"
  });
  var height = $(splide.Components.Elements.slides[splide.index]).outerHeight();
  updateSliderHeight(splide, height);
  setTimeout(function () {
    updateSliderHeight(splide, height);
  }, 2000);
}
function updateSliderHeight(splide, height) {
  if (splide && height) {
    $(splide.Components.Elements.track).animate({
      height: height + "px"
    }, {
      duration: splide.options.speed
      //complete: function () { }
    });
  }
}

;

/**
 * How to use our splide configs (SIMPLE):
 * 
 * 1. Get your slider HTML onto the page (i.e. from a View or static block). Basic splide classes and markup are required here.
 * 2. Make sure the ".splide" element has a custom data attribute 'data-splide-preset' (e.g. 'data-splide-preset="single"')
 * 3. That's it. The code below will locate your ".splide[data-splide-preset]" element and render it using the specified configuration.
 * 
 */

/*
 Global splide config. Used a base for ALL splide sliders. 
 */
window.globalSplideConfig = {
  type: 'loop'
  //start: 0,
  //perPage: 1,
  //perMove: 1,
  //pagination: true,
  //arrows: false,
  //autoHeight: true,
  //rewind: false,
  //speed: '500',
  //autoplay: true,
  //easing: 'cubic-bezier(.12,.8,.47,.98)',
  //accessibility: true,
  //classes: {
  //    //arrows: 'splide__arrows your-class-arrows',
  //    //arrow: 'splide__arrow your-class-arrow',
  //    prev: 'splide__arrow--prev fas fa-chevron-left',
  //    next: 'splide__arrow--next fas fa-chevron-right',
  //},
  //throttle: 10, // throttle the resize function (default 100 ms)
};

/*
 Slider presets. These get merged with the globalSplideConfig options to configure ALL splide sliders throughout the site.
 */
window.SplideConfigurations = [/* Default configuration */
{
  name: "default",
  //start: 0,
  type: 'loop',
  perPage: 4,
  perMove: 1,
  gap: "20px",
  updateOnMove: true,
  arrows: true,
  pagination: false,
  breakpoints: {
    1600: {
      perPage: 3
    },
    1080: {
      perPage: 2
    },
    550: {
      perPage: 1
    }
  },
  variants: [{
    // config that inherits/overrides a parent config
    name: "default-no-dots",
    pagination: false
  }],
  on: {
    mounted: onMountedMultiItemSlider,
    beforeMounted: function (splide) {
      console.log("triggered beforeMounted event. Splide: ", splide);
    }
  }
}, /* Fade */
{
  name: "fade",
  type: 'fade',
  start: 0,
  perPage: 1,
  perMove: 1
}, /* Homeslideshow / Hero */
{
  name: "hero",
  type: 'fade',
  rewind: true,
  speed: "2000",
  start: 0,
  perMove: 1,
  autoplay: true
}, /* Single Slide Resources */
{
  name: "single",
  type: 'loop',
  start: 0,
  perPage: 1,
  perMove: 1,
  pagination: false,
  variants: [{
    name: "single-auto-height",
    autoHeight: true,
    fixedHeight: false,
    on: Object.assign(autoHeightEvents, {// combine shared events with custom ones
      // move: function(){}
    })
  }]
}, /* Double (2-item) sliders  */
{
  name: "double",
  type: 'loop',
  start: 0,
  perPage: 2,
  perMove: 2,
  gap: "2rem",
  breakpoints: {
    640: {
      perPage: 1,
      perMove: 1
    }
  }
}, /* ImageGallery sliders  */
{
  name: "imageGallery",
  type: 'loop',
  start: 0,
  perPage: 1,
  perMove: 1,
  pagination: false,
  padding: '0'
}, /* Triple (4-item) sliders  */
{
  name: "triple",
  type: 'loop',
  start: 0,
  perPage: 3,
  perMove: 3,
  gap: "2rem",
  breakpoints: {
    768: {
      perPage: 2,
      perMove: 2
    },
    640: {
      perPage: 1,
      perMove: 1
    }
  }
}, /* Quad (4-item) sliders  */
{
  name: "quad",
  type: 'loop',
  start: 0,
  perPage: 4,
  perMove: 4,
  gap: "2rem",
  breakpoints: {
    1024: {
      perPage: 3,
      perMove: 3
    },
    768: {
      perPage: 2,
      perMove: 2
    },
    640: {
      perPage: 1,
      perMove: 1
    }
  }
}, /* Custom */
{
  name: "custom",
  perPage: 5,
  perMove: 1,
  gap: "0rem",
  breakpoints: {
    1299: {
      perPage: 4
    },
    1024: {
      perPage: 3
    },
    640: {
      perPage: 2
    },
    500: {
      perPage: 1
    }
  }
}, {
  name: "custom2",
  perPage: 4,
  perMove: 1,
  gap: 0,
  breakpoints: {
    1299: {
      perPage: 3
    },
    1024: {
      perPage: 2
    },
    640: {
      perPage: 1
    }
  }
}];

/* Get a splide configration matching a given name */
function getSplideConfiguraion() {
  let splideConfigurationName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
  let mergedConfiguration = {};
  for (var configuration of window.SplideConfigurations) {
    if (configuration.name === splideConfigurationName) {
      mergedConfiguration = mergeConfigurations({}, configuration);
      break;
    } else if (configuration.hasOwnProperty("variants") && configuration.variants.length) {
      for (var variant of configuration.variants) {
        if (variant.name === splideConfigurationName) {
          mergedConfiguration = mergeConfigurations(configuration, variant);
          // remove unneeded properties
          delete mergedConfiguration.variants;
          //delete mergedConfiguration.name;
          break;
        }
      }
    }
  }
  mergedConfiguration = mergeConfigurations(window.globalSplideConfig, mergedConfiguration);
  return mergedConfiguration;
}

/* merge two splide configurations intelligently (rather than blindly overwriting each other) */
function mergeConfigurations(config1, config2) {
  let mergedConfiguration = Object.assign({}, config1, config2);

  // merge the "on" callbacks/arrays. this allows configurations to inherit event callbacks (such as 'mounted') from the default configuration (and variants to inherit from their parents)
  if (config1.hasOwnProperty("on") && config2.hasOwnProperty("on")) {
    for (const [eventName, config1Callbacks] of Object.entries(config1.on)) {
      // loop through the config1 on callbacks
      if (typeof config2.on[eventName] !== "undefined") {
        let config2Callbacks = config2.on[eventName] || [];
        mergedConfiguration.on[eventName] = mergeCallbacks(config1Callbacks, config2Callbacks);
      }
    }
  }
  return mergedConfiguration;
}

/* takes two arguments (function or array of functions) and returns a merged, unique array of those functions */
/* primarily used for combining the "on" agruments/callbacks of several splide configurations */
function mergeCallbacks(cbArray1, cbArray2) {
  cbArray1 = Array.isArray(cbArray1) ? cbArray1 : [cbArray1];
  cbArray2 = Array.isArray(cbArray2) ? cbArray2 : [cbArray2];
  return [...new Set([...cbArray1, ...cbArray2])]; // creates a unique merged array (removes duplicate function references)
}

/* Initiate a splide slider using one of our configurations and all of our custom logic. */
function initSplideSlider($selector, configurationName) {
  let $slider = $($selector);
  let configuration = getSplideConfiguraion(configurationName);
  let splide = new Splide($slider[0], configuration);

  /* register custom event callbacks defined in the configuration object */
  if (typeof configuration.on !== "undefined") {
    for (const eventName in configuration.on) {
      /* BEFORE MOUNT EVENT (custom CF event) - allows us to do things prior to initializing a slider */
      if (eventName === "beforeMounted") {
        let beforeMountedCallbacks = Array.isArray(configuration.on[eventName]) ? configuration.on[eventName] : [configuration.on[eventName]];
        /* loop through the beforeMounted callbacks and run them */
        beforeMountedCallbacks.forEach(function (beforeMountedCallback, index) {
          if (typeof beforeMountedCallback === "function") {
            beforeMountedCallback(splide);
          }
        });
        delete configuration.on[eventName]; // remove these non-splide events as they are not needed beyond this point.
        continue;
      }

      /* event binding - allows for mutiple functions to be bound to a single callback. */
      let callbacks = Array.isArray(configuration.on[eventName]) ? configuration.on[eventName] : [configuration.on[eventName]];
      for (const callback of callbacks) {
        if (typeof callback === "function") {
          splide.on(eventName, function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            // this is a closure. we capture the default args, then add our own 
            callback(...args, splide);
          });
        }
      }
    }
  }

  // add it to our list of registered sliders (for potential later use)
  window.splideSliders = window.splideSliders || [];
  window.splideSliders.push({
    el: $slider,
    splide,
    configuration
  });

  //splide.mount({ Grid });
  splide.mount();
}

/* Loop through our widget / view sliders and initiate them using their preset configs */
window.splideSliders = window.splideSliders || [];
$(".splide[data-splide-preset]").not(".is-active").each(function (i, el) {
  let $slider = $(this);
  let configurationName = $slider.attr("data-splide-preset");
  initSplideSlider($slider, configurationName);
});

/****************************************************************************************************/
/* Search Box Non-Modal Toggle */
/****************************************************************************************************/

$(function () {
  $("a.searchExpand").on("click", function () {
    $(".searchHiddenWrapper").slideToggle();
  });
  $("button.searchCollapse").on("click", function () {
    $(".searchHiddenWrapper").slideToggle();
  });
});

/****************************************************************************************************/
/* Forms / Autofill */
/****************************************************************************************************/

// SEARCH BOX - PLACEHOLDER TEXT
$('.search input[type="text"]').attr("placeholder", "How Can We Help You?");

// Fix for Chrome Form Autofill for our contact form
$(".contactForm input[name*=Name]").attr('autocomplete', 'name');
$(".contactForm input[name*=Email]").attr('autocomplete', 'email');
$(".contactForm input[name*=Phone]").attr('autocomplete', 'tel');
// Or you could turn it off
//$('form').attr('autocomplete', 'off');

/****************************************************************************************************/
/* Misc */
/****************************************************************************************************/

// check if we're running inside the SF Page editor
function isSitefinityEditor() {
  return $("body").hasClass("sfPageEditor") || typeof sitefinity === "object";
}
function isLocalhost() {
  return window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "::1";
}

// Clickable items (e.g. a clickable article card with nested links)
$(document).on("click", ".clickable", function (event) {
  var $this = $(this);
  if (!isSitefinityEditor()) {
    // If there's not data-url, then find the first child el with an href and use that
    var itemUrl = "";
    var target = "_self"; // default

    // allow links within to work
    if ($(event.target).is('a[href]')) {
      return;
    }

    // First check for data atts. If none, use the first child link
    else if (typeof $this.data("url") !== 'undefined' && $this.data("url").length) {
      itemUrl = $this.data("url");
      if (typeof $this.data("target") !== 'undefined' && $this.data("target").length) {
        target = $this.data("target");
      }
    } else {
      var $firstLinkFound = $this.find("a[href]").first();
      itemUrl = $firstLinkFound.attr("href");
      target = $firstLinkFound.attr("target") ? $firstLinkFound.attr("target") : target;
    }
    window.open(itemUrl, target);
  }
});

// Play Audio 
window.addEventListener('DOMContentLoaded', function () {
  $(document).on("click", ".audioFile a", function () {
    playAudio($(this).attr("data-audioid"));
    return false;
  }).on("keypress", function (e) {
    if (e.which === 13) {
      // enter key code
      playAudio($(this).attr("data-audioid"));
      return false;
    }
  });

  // Play Audio
  function playAudio($audioid) {
    var audioFile = $('#' + $audioid).addClass("playing").get(0).play();
  }
});

///Copyright Script
var publishedDate = 2022;
var year = $('.copyrightYear');
if (year.html() == publishedDate) {
  year.html(publishedDate);
} else {
  year.html(publishedDate + '-' + new Date().getFullYear());
}
document.addEventListener('DOMContentLoaded', function () {
  //callback function: simply adds a class when the element is in the viewport

  function observerCallback(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('inViewport');
      }
    });
  }

  //only activate when an element is 20% visible
  let observerOptions = {
    threshold: .20
  };

  //create an intersection observer to watch
  var observer = new IntersectionObserver(observerCallback, observerOptions);
  let wrapperTarget = '.checkViewport:not(.sfPageEditor .checkViewport)'; // includes stop adding inViewPort to templates during editing
  if (!!window.IntersectionObserver) {
    //check if browser supports it, 
    document.querySelectorAll(wrapperTarget).forEach(i => {
      if (i) {
        observer.observe(i);
      }
    });
  } else {
    // if not, unhide everything
    document.querySelectorAll(wrapperTarget).forEach(i => {
      if (i) {
        i.classList.remove('wrapper');
      }
    });
  }

  ////make jumpMenu stick to the top of the
  //const el = document.querySelector(".jumpMenuWrapper")
  //const observer2 = new IntersectionObserver(
  //    ([entry]) => entry.target.querySelector(".stickyWrapper").classList.toggle("stuck", entry.intersectionRatio < 1),
  //    { threshold: [1] }
  //);
  //observer2.observe(el);
});

//Kendo treeview to create accordions in layouts
window.addEventListener('DOMContentLoaded', function () {
  var $treeViewAccordion = $(".accordionGroup");
  $treeViewAccordion.kendoTreeView({
    expandMode: "multiple"
  });
});

// Clear Local Storage querydata and filters if not on a detail or filtered content page
window.addEventListener('DOMContentLoaded', function () {
  var detailPage = document.querySelector(".detailPage");
  var filtersContainer = document.querySelector(".filteredContent");
  var isLocalStorageDisabled = false;
  var isPageReload = performance.getEntriesByType("navigation")[0].type === "reload";
  if (filtersContainer) {
    isLocalStorageDisabled = filtersContainer.dataset.localStorageDisabled === "true" ? true : false;
  }
  var canClearLocalStorage = !detailPage && !filtersContainer || isLocalStorageDisabled || isPageReload;
  if (canClearLocalStorage || isPageReload) {
    localStorage.removeItem("cf_filteredcontentscrollto");
    localStorage.removeItem("cf_filteredcontent");
    localStorage.removeItem("cf_filteredcontentsearchparams");
    if (isPageReload && filtersContainer) {
      var dropdownLists = document.querySelectorAll(".k-dropdown select");
      if (dropdownLists) {
        for (let i = 0; i < dropdownLists.length; i++) {
          dropdownLists[i].options[0].selected = true;
          dropdownLists[i].previousSibling.querySelector(".k-input").innerText = dropdownLists[i].options[0].innerText;
        }
      }
      document.querySelector(".keywordSearch").value = "";
    }
  }
});
/* Toggle Filters Groups on Checkbox FilteredContent */
document.addEventListener('click', function (event) {
  if (event.target.classList.contains('filterToggle')) {
    // Prevent Default Action
    event.preventDefault();
    const toggleFilterClicked = event.target;
    const toggleFilterContentToControl = toggleFilterClicked.nextElementSibling;
    if (toggleFilterClicked.classList.contains('active')) {
      /* already has 'active' the class remove it */
      toggleFilterClicked.classList.remove('active');
      toggleFilterContentToControl.classList.remove('active');
    } else {
      /* add the 'active' class */
      toggleFilterClicked.classList.add('active');
      toggleFilterContentToControl.classList.add('active');
    }
  }
}, false);
jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, {
      passive: !ns.includes("noPreventDefault")
    });
  }
};
jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchmove", handle, {
      passive: !ns.includes("noPreventDefault")
    });
  }
};
jQuery.event.special.wheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("wheel", handle, {
      passive: true
    });
  }
};
jQuery.event.special.mousewheel = {
  setup: function (_, ns, handle) {
    this.addEventListener("mousewheel", handle, {
      passive: true
    });
  }
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// #region Kendo Tabstrip
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function setupTabstrips() {
  var $tabstrips = $(".tabstrip");
  if (!$tabstrips.length) {
    return;
  }
  var tabstrip = $tabstrips.each(function () {
    $(this).kendoTabStrip({
      tabPosition: "top",
      scrollable: false,
      animation: {
        open: {
          effects: "fadeIn"
        }
      }
    });
  }).data("kendoTabStrip");
  tabstrip.select(0); // select and expand the first item
}

setupTabstrips();

// #endregion
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// #region Kendo Panelbar
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Setup panelbar lists (join us / students pages)
function setupPanelBars() {
  var $panelbarItems = $(".panelbarTitle");
  if (!$panelbarItems.length) {
    return;
  }
  $panelbarItems.each(function () {
    var $panelView = $(this).closest(".panelbarOuter").not(".k-panelbar");
    $panelView.uniqueId(); // this is important - keyboard nav doesn't work properly without it
    if ($panelView.length) {
      var panelbar = $panelView.kendoPanelBar({
        expandMode: "multiple"
      }).data("kendoPanelBar");
      //$panelView.find(".k-icon").append('<span class="fa-sharp fa-light fa-plus"></span><span class="fa-sharp fa-light fa-minus"></span>');
      //panelbar.expand(".k-first").select(".k-first"); // expand the first item
    }
  });
}

setupPanelBars();

//window.addEventListener('DOMContentLoaded', function () {

//    var $treeViewCareers = $(".listView.careers");

//    $treeViewCareers.kendoTreeView({
//        expandMode: "multiple"
//    });
//});
// #endregion
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**********************************************************************************************************************/
/* region Background Lines */
/**********************************************************************************************************************/

$(document).ready(function () {
  if (isSitefinityEditor()) {
    return;
  }

  // Ensure GSAP and ScrollTrigger are loaded
  gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
  ``;
  // Extract the template content
  let templateVariation1b = $("#variation1b").html();
  let templateVariation1 = $("#variation1").html();
  let templateVariation2 = $("#variation2").html();
  let templateVariation3 = $("#variation3").html();
  let templateVariation3b = $("#variation3b").html();
  let templateVariation4 = $("#variation4").html();
  let templatevariationLeftToRightTop400 = $("#variationLeftToRightTop400").html();
  let templatevariationRightToLeftTop400 = $("#variationRightToLeftTop400").html();
  let templateVariation4VerticalOnly = $("#variation4VerticalOnly").html();
  let templateVariation3Middle = $("#variation3Middle").html();
  let templateVariation4Middle = $("#variation4Middle").html();
  $(".withLines").each(function () {
    var template = ""; // templateVariation1; // default to 1
    if ($(this).hasClass("lineVariation1b")) {
      template = templateVariation1b;
      //$(this).addClass("animate");
    } else if ($(this).hasClass("lineVariation1")) {
      template = templateVariation1;
      //$(this).addClass("animate");
    } else if ($(this).hasClass("lineVariation2")) {
      template = templateVariation2;
    } else if ($(this).hasClass("lineVariation3")) {
      template = templateVariation3;
    } else if ($(this).hasClass("lineVariation3b")) {
      template = templateVariation3b;
    } else if ($(this).hasClass("lineVariation4")) {
      template = templateVariation4;
    } else if ($(this).hasClass("lineVariation4VerticalOnly")) {
      template = templateVariation4VerticalOnly;
    } else if ($(this).hasClass("lineVariationLeftToRightTop400")) {
      template = templatevariationLeftToRightTop400;
    } else if ($(this).hasClass("lineVariationRightToLeftTop400")) {
      template = templatevariationRightToLeftTop400;
    } else if ($(this).hasClass("lineVariationBlueOnly") && $(this).hasClass("lineThroughMiddle")) {
      template = templateVariation4Middle;
    } else if ($(this).hasClass("lineVariationBlueOnlyReverse") && $(this).hasClass("lineThroughMiddle")) {
      template = templateVariation3Middle;
    } else if ($(this).hasClass("lineVariationBlueOnly")) {
      template = templateVariation4;
    } else if ($(this).hasClass("lineVariationBlueOnlyReverse")) {
      template = templateVariation3;
    } else {
      return;
    }

    // Clone the template and prepend it to each .withLines element
    let linesDiv = $(template).clone();
    $(this).prepend(linesDiv);
  });

  // inject the SVGs
  SVGInject(document.querySelectorAll("img.injectable"), {
    onAllFinish: initLinesAnimation,
    makeIdsUnique: true // for this reason, we shouldn't use ids to refer to the svgs/paths
  });
});

//var timelines = [];
//function initLinesAnimation() {
//    $(".withLines").each(function (index, section) {
//        let $section = $(section);
//        let $bluePaths = $section.find("path.line.blue");
//        let $yellowPaths = $section.find("path.line.yellow");
//        let $svg = $section.find("svg.blue-line-img");

//        if (!$svg.length) return; // No SVGs detected, so bail

//        // Function to set up stroke-dasharray and stroke-dashoffset
//        function setupPath($path) {
//            let path = $path[0];
//            let length = path.getTotalLength();
//            path.style.setProperty("--length", `${length}px`)

//            //const length = path.getTotalLength();
//            const ctm = path.getScreenCTM();

//            if (ctm) {
//                const scaleX = Math.sqrt(ctm.a ** 2 + ctm.b ** 2);
//                const scaleY = Math.sqrt(ctm.c ** 2 + ctm.d ** 2);
//                const adjustedLength = length * (scaleX + scaleY) / 2; // Average scaling factor
//                path.style.setProperty("--length-adjusted", `${length}px`)
//                console.log("Adjusted Length:", adjustedLength);
//            } else {
//                console.log("Path Length:", length);
//            }

//            gsap.set(path, { strokeDasharray: length, strokeDashoffset: (length) });
//            return length;
//        }

//        // Set initial values for paths
//        let blueLength = setupPath($bluePaths);
//        let yellowLengths = $yellowPaths.map(function (_, p) {
//            return setupPath($(p));
//        }).get();

//        // Create a timeline for each section
//        let sectionTimeline = gsap.timeline({
//            paused: true,
//            scrollTrigger: {
//                trigger: $section,
//                start: "top 50%",
//                end: "bottom 50%",
//                once: true,
//                toggleClass: "animate",
//                toggleActions: (index === 0) ? "play none none none" : "none none none none",
//                preventOverlaps: true,
//                onEnter: function () {
//                    if (!timelines.length) return;
//                    let tl = timelines[index - 1];
//                    if (tl && typeof tl.progress === "function") {
//                        tl.progress(1);
//                        sectionTimeline.play();
//                    }
//                }
//            }
//        });

//        // Animate blue path
//        sectionTimeline.to($bluePaths[0], {
//            strokeDashoffset: 0,
//            duration: 2,
//            ease: "power2.out"
//        });

//        // Animate yellow paths (starting 0.5s earlier)
//        sectionTimeline.to($yellowPaths, {
//            strokeDashoffset: 0,
//            duration: 2,
//            ease: "power2.out",
//            stagger: 0.2
//        }, "-=1.5");

//        // Add this timeline to an array for later access
//        timelines.push(sectionTimeline);
//    });
//}

var globalTimeline = gsap.timeline({});
var timelines = [];
function initLinesAnimation() {
  $(".withLines").each(function (index, section) {
    let $section = $(section);
    let $bluePaths = $section.find(".line.blue");
    let $yellowGroups = $section.find(".yellow-lines .group");
    var start = "top 70%";
    var end = "bottom 30%";
    if (index === 0) {
      start = "top 100%";
      end = "bottom 0%";
    }

    // Create a timeline for each section
    let sectionTimeline = gsap.timeline({
      paused: true,
      ease: "power2.out",
      // Add easing to the whole timeline
      scrollTrigger: {
        trigger: $section,
        start: start,
        end: end,
        once: true,
        toggleClass: "animate",
        toggleActions: index === 0 ? "play none none none" : "none none none none",
        preventOverlaps: true,
        onEnter: function () {
          if (!timelines.length) {
            return;
          }
          let tl = timelines[index - 1];
          if (tl && typeof tl.progress === "function") {
            tl.progress(1);
            sectionTimeline.play();
          }
        }
      }
    });

    // Add label for blue animation start
    sectionTimeline.addLabel("blueStart");

    // Loop through each blue path and animate based on data-width or data-height
    $bluePaths.each(function () {
      let $path = $(this);
      let width = $path.attr("data-width");
      let height = $path.attr("data-height");
      if (width) {
        let isComplexValue = width.includes("%") || width.includes("rem") || width.includes("calc(");
        sectionTimeline.fromTo($path, {
          width: isComplexValue ? "0%" : "0rem"
        }, {
          width: width,
          duration: 1
        }
        //"blueStart" // Blue animations start at this label
        );
      } else if (height) {
        let isComplexValue = height.includes("%") || height.includes("rem") || height.includes("calc(");
        sectionTimeline.fromTo($path, {
          height: isComplexValue ? "0%" : "0rem"
        }, {
          height: height,
          duration: 1
        }
        //"blueStart" // Blue animations start at this label
        );
      }
    });

    // Delay yellow groups animation 0.5s after blue starts, then stagger groups using a nested timeline
    sectionTimeline.addLabel("yellowStart", "blueStart+=0.5");
    let yellowTimeline = gsap.timeline();

    // Add label for yellow animation start inside the nested timeline
    yellowTimeline.addLabel("yellowGroupStart");
    $yellowGroups.each(function (groupIndex) {
      let $group = $(this);
      let groupDelay = groupIndex * 0.2; // Stagger groups by 0.2s
      let groupTimeline = gsap.timeline();
      let $yellowPaths = $group.find(".line.yellow");
      $yellowPaths.each(function () {
        let $path = $(this);
        let animationProperty = $path.hasClass("horizontal") ? "width" : "height";
        groupTimeline.fromTo($path, {
          [animationProperty]: "0%"
        }, {
          [animationProperty]: "100%",
          duration: 1
        });
      });
      yellowTimeline.add(groupTimeline, "yellowGroupStart+=" + groupDelay);
    });
    sectionTimeline.add(yellowTimeline, "yellowStart");

    // Add this timeline to an array for later access
    timelines.push(sectionTimeline);
  });
}
if (isLocalhost()) {
  $(".withLines").on("click", function () {
    timelines[0].restart();
  });
}
document.addEventListener("DOMContentLoaded", function () {
  const searchShow = document.querySelector(".searchShow"); // Search icon button
  const searchOuter = document.querySelector(".searchOuter"); // The parent container of the search box
  // Toggle the search box and icon when search icon is clicked
  searchShow.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent default anchor behavior

    // Toggle the 'open' class on the searchOuter to show/hide the search box
    searchOuter.classList.toggle("open");
  });
});

/* endregion */
/**********************************************************************************************************************/

window.addEventListener('DOMContentLoaded', function () {
  const targetId = window.location.hash; // Get the hash from the URL

  if (targetId) {
    setTimeout(function () {
      const targetElement = document.querySelector(targetId); // Find the target element
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start' // Align the target element to the top of the viewport
        });
      }
    }, 400); // Wait for a brief moment to ensure content is ready
  }
});